import actions from '@cms/i18n/locale/nl_NL/actions.json';
import articleblock from '@cms/i18n/locale/nl_NL/articleblock.json';
import articles from '@cms/i18n/locale/nl_NL/articles.json';
import author from '@cms/i18n/locale/nl_NL/author.json';
import betting from '@cms/i18n/locale/nl_NL/betting.json';
import comments from '@cms/i18n/locale/nl_NL/comments.json';
import common from '@cms/i18n/locale/nl_NL/common.json';
import competitions from '@cms/i18n/locale/nl_NL/competitions.json';
import components from '@cms/i18n/locale/nl_NL/components.json';
import contact from '@cms/i18n/locale/nl_NL/contact.json';
import createPost from '@cms/i18n/locale/nl_NL/create-post.json';
import datetime from '@cms/i18n/locale/nl_NL/datetime.json';
import error from '@cms/i18n/locale/nl_NL/error.json';
import footer from '@cms/i18n/locale/nl_NL/footer.json';
import image from '@cms/i18n/locale/nl_NL/image.json';
import livescores from '@cms/i18n/locale/nl_NL/livescores.json';
import meta from '@cms/i18n/locale/nl_NL/meta.json';
import names from '@cms/i18n/locale/nl_NL/names.json';
import newslist from '@cms/i18n/locale/nl_NL/newslist.json';
import playerRating from '@cms/i18n/locale/nl_NL/player-rating.json';
import postComment from '@cms/i18n/locale/nl_NL/post-comment.json';
import premium from '@cms/i18n/locale/nl_NL/premium.json';
import profile from '@cms/i18n/locale/nl_NL/profile.json';
import relatedNews from '@cms/i18n/locale/nl_NL/related-news.json';
import search from '@cms/i18n/locale/nl_NL/search.json';
import secure from '@cms/i18n/locale/nl_NL/secure.json';
import sidebar from '@cms/i18n/locale/nl_NL/sidebar.json';
import standing from '@cms/i18n/locale/nl_NL/standing.json';
import stats from '@cms/i18n/locale/nl_NL/stats.json';
import subscribe from '@cms/i18n/locale/nl_NL/subscribe.json';
import uploadSpots from '@cms/i18n/locale/nl_NL/upload-spots.json';
import url from '@cms/i18n/locale/nl_NL/url.json';
import user from '@cms/i18n/locale/nl_NL/user.json';
import videos from '@cms/i18n/locale/nl_NL/videos.json';

import { Ns } from './types';

export const I18N_RESOURCES: Record<Ns, any> = {
    [Ns.Actions]: actions,
    [Ns.Articleblock]: articleblock,
    [Ns.Articles]: articles,
    [Ns.Author]: author,
    [Ns.Betting]: betting,
    [Ns.Comments]: comments,
    [Ns.Common]: common,
    [Ns.Competitions]: competitions,
    [Ns.Components]: components,
    [Ns.Contact]: contact,
    [Ns.CreatePost]: createPost,
    [Ns.Datetime]: datetime,
    [Ns.Error]: error,
    [Ns.Footer]: footer,
    [Ns.Image]: image,
    [Ns.Livescores]: livescores,
    [Ns.Meta]: meta,
    [Ns.Names]: names,
    [Ns.Newslist]: newslist,
    [Ns.PlayerRating]: playerRating,
    [Ns.PostComment]: postComment,
    [Ns.Premium]: premium,
    [Ns.Profile]: profile,
    [Ns.RelatedNews]: relatedNews,
    [Ns.Search]: search,
    [Ns.Secure]: secure,
    [Ns.Sidebar]: sidebar,
    [Ns.Standing]: standing,
    [Ns.Stats]: stats,
    [Ns.Subscribe]: subscribe,
    [Ns.Url]: url,
    [Ns.UploadSpots]: uploadSpots,
    [Ns.User]: user,
    [Ns.Videos]: videos,
};
